import {
	type Account,
	accountNeedsReauth,
	isLbStrategy,
	StrategyName,
} from "@ccflare/types";

export function isValidStrategy(strategy: string): strategy is StrategyName {
	return isLbStrategy(strategy);
}

// Default load balancing strategy
export const DEFAULT_STRATEGY = StrategyName.Session;

// Helper to check if an account is available (not paused, not rate-limited,
// and not waiting for a re-login after a permanent auth failure)
export function isAccountAvailable(
	account: Account,
	now = Date.now(),
): boolean {
	return (
		!account.paused &&
		!accountNeedsReauth(account) &&
		(!account.rate_limited_until || account.rate_limited_until < now)
	);
}
